import { createUseStyles } from "react-jss";
import breakpoints from "assets/breakpoints";
export const useStyles = createUseStyles({
  orgdetails__page: {
    backgroundColor: "rgb(var(--silver))",
    // headerCommon
    "& .headerCommon": {
      borderBottom: "1px solid rgb(var(--light))",
    },
    // footerCommon
    "& .footerCommon": {
      borderTop: "1px solid rgb(var(--light))",
      backgroundColor: "rgb(var(--white))",
    },
    // orgd__section
    "& .orgd__section": {
      paddingBlock: "24px",
      minHeight: "calc(100vh - 136px)",
      backgroundColor: "rgb(var(--silver))",
      "& .orgd__inner": {
        "& .orgd__left": {
          "& .orgd__content": {
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
            "& .orgd__conitems": {
              "&:not(:last-child)": {
                borderBottom: "1px solid rgb(var(--light))",
              },
              "&:not(:first-child)": {
                padding: "12px",
                [breakpoints.SCREEN_MD_MIN]: {
                  padding: "20px",
                },
              },
              "& .conitems__title": {
                fontSize: "18px",
                marginBottom: "10px",
              },
              "&.conitems__top": {
                padding: "",
                [breakpoints.SCREEN_MD_MIN]: {
                  padding: "20px",
                },
                [breakpoints.SCREEN_MD_MAX]: {
                  padding: "12px",
                },
                "& .orgd__title": {
                  "& .orgd__tileft": {
                    "& .tileft__tpathway": {
                      lineHeight: "1.1",
                      "& .tileft__items": {
                        fontSize: "13px",
                        "&:not(:last-child)": {
                          marginRight: "4px",
                        },
                      },
                    },
                    "& h3": {
                      fontSize: "22px",
                    },
                    "& p": {
                      fontSize: "13px",
                    },
                  },
                  "& .orgd__tiright": {
                    padding: "8px 18px",
                    border: "1px solid rgb(var(--light))",
                    boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
                  },
                },
                // conitems__img
                "& .conitems__img": {
                  width: "100%",
                  height: "164px",
                  flex: "0 0 100%",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor: "rgb(var(--silver))",
                  border: "1px solid rgb(var(--light) / 0.50)",
                  [breakpoints.SCREEN_MD_MIN]: {
                    width: "280px",
                    flex: "0 0 280px",
                  },
                  [breakpoints.SCREEN_MD_MAX]: {
                    width: "100%",
                    flex: "0 0 164px",
                  },
                  "& > img": {
                    borderRadius: "8px",
                    padding: "10px",
                  },
                  "& .no__img": {
                    borderRadius: "8px",
                    width: "100%",
                    height: "100%",
                    "& > span": {
                      fontSize: "14px",
                    },
                  },
                  "& .sliderCommon": {
                    "& .carousel": {
                      "& .carousel-inner": {
                        width: "100%",
                        height: "164px",
                        flex: "0 0 100%",
                        [breakpoints.SCREEN_MD_MIN]: {
                          width: "280px",
                          flex: "0 0 280px",
                        },
                        [breakpoints.SCREEN_MD_MAX]: {
                          width: "100%",
                        },
                        "& .carousel-item": {
                          height: "100%",
                        },
                      },
                    },
                  },
                },
              },
              // conitems__summary
              "&.conitems__summary": {
                [breakpoints.SCREEN_MD_MAX]: {
                  marginTop: "20px",
                },
                "& .summary__content": {
                  "& p": {
                    fontSize: "14px",
                    lineHeight: "24px",
                    "&:last-child": {
                      marginBottom: "0",
                    },
                  },
                },
              },
              // conitems__pathway
              "&.conitems__pathway": {
                "& .patsub__box": {
                  height: "100%",
                  padding: "16px",
                  backgroundColor: "rgb(var(--white))",
                  border: "1px solid rgb(var(--light))",
                  "& > h6": {
                    fontSize: "14px",
                    marginBottom: "0",
                  },
                  "& .patsub__list": {
                    listStyle: "none",
                    paddingBottom: "1px",
                    "& > li": {
                      fontSize: "14px",
                      paddingLeft: "14px",
                      lineHeight: "1.1",
                      "&:before": {
                        content: '""',
                        width: "4px",
                        height: "4px",
                        borderRadius: "50rem",
                        backgroundColor: "rgb(var(--gray))",
                        position: "absolute",
                        top: "6px",
                        left: "0",
                      },
                      "&:not(:last-child)": {
                        marginBottom: "6px",
                      },
                    },
                  },
                },
              },
              // conitems__targetgroup
              "&.conitems__targetgroup": {
                "& .target__list": {
                  maxHeight: "240px",
                  overflow: "hidden auto",
                  display: "grid",
                  columnGap: "24px",
                  rowGap: "6px",
                  listStyle: "none",
                  gridTemplateColumns: "1fr",
                  [breakpoints.SCREEN_XS_MIN]: {
                    gridTemplateColumns: "1fr 1fr",
                  },
                  [breakpoints.SCREEN_MD_MIN]: {
                    gridTemplateColumns: "1fr 1fr 1fr",
                  },
                  [breakpoints.SCREEN_LG_MIN]: {
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  },
                  "& > li": {
                    fontSize: "14px",
                    paddingLeft: "16px",
                    "&:before": {
                      content: '""',
                      width: "4px",
                      height: "4px",
                      borderRadius: "50rem",
                      backgroundColor: "rgb(var(--gray))",
                      position: "absolute",
                      top: "9px",
                      left: "0",
                    },
                  },
                },
              },
              // conitems__criteria
              "&.conitems__criteria": {
                "& .criteria__box": {
                  height: "100%",
                  padding: "16px",
                  backgroundColor: "#F5F7FA",
                  "& > h6": {
                    fontSize: "14px",
                    marginBottom: "0",
                  },
                  "& .criteria__list": {
                    listStyle: "none",
                    paddingBottom: "1px",
                    "& > li": {
                      fontSize: "14px",
                      paddingLeft: "14px",
                      lineHeight: "1.1",
                      "&:before": {
                        content: '""',
                        width: "4px",
                        height: "4px",
                        borderRadius: "50rem",
                        backgroundColor: "rgb(var(--gray))",
                        position: "absolute",
                        top: "6px",
                        left: "0",
                      },
                      "&:not(:last-child)": {
                        marginBottom: "6px",
                      },
                    },
                  },
                },
              },
              // conitems__additionalinfo
              "&.conitems__additionalinfo": {
                "& .nav-tabs": {
                  border: "0",
                  gap: "8px",
                  "& .nav-item": {
                    "& > button": {
                      fontSize: "14px",
                      padding: "8px 18px",
                      minHeight: "40px",
                      borderRadius: "50rem",
                      fontWeight: "var(--fw-600)",
                      color: "rgb(var(--gray))",
                      backgroundColor: "rgb(var(--white))",
                      border: "1px solid rgb(var(--light))",
                      boxShadow: "0 0 10px rgb(var(--black) / 0.03)",
                      "&:hover:not(.active), &:focus:not(.active)": {
                        color: "rgb(var(--dark))",
                        borderColor: "rgb(var(--gray) / 0.20) !important",
                        backgroundColor: "#F5F7FA",
                      },
                      "&.active": {
                        color: "rgb(var(--dark))",
                        borderColor: "rgb(var(--gray))",
                        backgroundColor: "#F5F7FA",
                      },
                    },
                  },
                },
              },
              // conitems__reviews
              "&.conitems__reviews": {
                "& .review__head": {
                  "& .rhead__left": {
                    padding: "16px",
                    borderRadius: "8px",
                    backgroundColor: "#F9F9F9",
                    border: "1px solid rgb(var(--light))",
                    "& h1": {
                      fontSize: "40px",
                    },
                    "& p": {
                      fontSize: "14px",
                    },
                  },
                  "& .rhead__right": {
                    "& .rhead__ritems": {
                      "&:not(:last-child)": {
                        marginBottom: "16px",
                      },
                      "& p": {
                        fontSize: "14px",
                        "&.star": {
                          width: "28px",
                        },
                        "&.percent": {
                          width: "28px",
                        },
                      },
                    },
                  },
                },
                "& .review__body": {
                  "& .rbody__items": {
                    paddingBlock: "16px",
                    "& p": {
                      fontSize: "14px",
                      lineHeight: "24px",
                    },
                    "&:not(:last-child)": {
                      borderBottom: "1px solid rgb(var(--light))",
                    },
                  },
                },
              },
            },
          },
        },
        "& .orgd__right": {
          "& .orgd__rbox": {
            position: "sticky",
            top: "14px",
            borderRadius: "8px",
            border: "1px solid rgb(var(--light))",
            boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
            "& .orgd__rcard": {
              padding: "16px",
              "&:not(:last-child)": {
                borderBottom: "1px solid rgb(var(--light))",
              },
              // orgd__review
              "& .orgd__review": {
                "& span": {
                  fontSize: "24px",
                  lineHeight: "1.2",
                  "&.small": {
                    fontSize: "14px",
                  },
                },
                "& svg": {
                  fontSize: "18px",
                  position: "relative",
                  top: "-1px",
                },
                "&:hover": {
                  "& svg": {
                    animation: "org__pop 0.4s linear infinite",
                  },
                },
              },
              // orgd__contact
              "& .orgd__contact": {
                "& .orgd__coitems": {
                  "& .coitems__icn": {
                    flex: "0 0 30px",
                    maxWidth: "30px",
                    height: "30px",
                  },
                  "& .coitems__content": {
                    flex: "1",
                    width: "100%",
                    maxWidth: "100%",
                    WebkitLineClamp: "1",
                    WebkiBboxOrient: "vertical",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    "& > small": {
                      fontSize: "12px",
                      color: "rgb(var(--gray) / 0.70)",
                    },
                    "& > p, & > a": {
                      fontSize: "16px",
                      paddingBottom: "4px",
                      display: "-webkit-box",
                      maxWidth: "100%",
                      WebkitLineClamp: "1",
                      WebkiBboxOrient: "vertical",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    },
                  },
                  "&:not(:last-child)": {
                    paddingBottom: "16px",
                    marginBottom: "12px",
                    borderBottom: "1px solid rgb(var(--light))",
                  },
                  "&:hover": {
                    "& .coitems__icn": {
                      "& > svg": {
                        animation: "org__pop 0.4s linear infinite",
                      },
                    },
                  },
                },
              },
              // orgd__social
              "& .orgd__social": {
                "& .social__items": {
                  width: "44px",
                  height: "44px",
                  border: "1px solid rgb(var(--light))",
                  "& svg": {
                    fontSize: "18px",
                  },
                  "&:hover": {
                    "& svg": {
                      animation: "org__pop 0.4s linear infinite",
                    },
                  },
                },
              },
            },
          },
        },
      },
    },

    // orgdetails__clinks
    "& .orgdetails__clinks": {},
  },
});
